import { Modal, notification } from 'antd';
import { useIntl } from 'react-intl';

import { i18n } from '@/shared/config';
import { useAppDispatch } from '@/shared/hooks';

import * as billingModel from '../model';

export const useTurnOffAutoRenewModal = () => {
  const dispatch = useAppDispatch();
  const { formatMessage } = useIntl();

  return ({
    subscriptionID,
    accountID,
    canEditProducts,
  }: {
    subscriptionID: string;
    accountID: string;
    canEditProducts: boolean;
  }) => {
    if (!canEditProducts) {
      notification.error({
        message: formatMessage({
          id: 'turnOffAutoRenewModal.noPermission',
          defaultMessage: 'You do not have permission to turn off auto-renew.',
        }),
      });

      return;
    }

    Modal.confirm({
      title: formatMessage({
        id: 'turnOffAutoRenewModal.title',
        defaultMessage: 'Turn off auto-renew',
      }),
      cancelText: formatMessage(i18n.modal.no),
      okText: formatMessage({
        id: 'turnOffAutoRenewModal.okText',
        defaultMessage: 'Turn off auto-renew',
      }),
      content: formatMessage({
        id: 'turnOffAutoRenewModal.text',
        defaultMessage: 'Are you sure you want to turn off auto-renew?',
      }),
      okButtonProps: {
        danger: true,
      },
      centered: true,
      onOk: () =>
        dispatch(
          billingModel.thunks.createOrder({
            AccountID: accountID,
            Effect: {
              case: 'SubscriptionSetAutoRenewal',
              value: {
                SubscriptionStateID: subscriptionID,
                IsAutoRenewal: false,
              },
            },
          }),
        ),
    });
  };
};
